import { FC, useState } from 'react';
import BucketEntity from '../../../../domain/entities/BucketEntity';
import ButtonComponent from '../../../components/button/ButtonComponent';
import { ButtonType } from '../../../components/button/ButtonComponentProps';

interface MoveUserModalProps {
    allBuckets: BucketEntity[];
    selectedCount: number;
    onConfirm: (targetBucket: BucketEntity) => void;
    onCancel: () => void;
}

const MoveUserModal: FC<MoveUserModalProps> = ({ allBuckets, selectedCount, onConfirm, onCancel }) => {
    const [selectedTarget, setSelectedTarget] = useState<BucketEntity | null>(null);
    const [search, setSearch] = useState<string>('');

    const filteredBuckets = allBuckets.filter(b =>
        b.name.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div className="move_user_modal">
            <p>Move <strong>{selectedCount}</strong> user(s) to a new bucket:</p>

            <input
                type="text"
                className="form-control mb-3"
                placeholder="Search target bucket..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
            />

            <div className="move_user_bucket_list">
                {filteredBuckets.map(bucket => (
                    <div
                        key={bucket.bucket_id}
                        className={`move_user_bucket_item ${selectedTarget?.bucket_id === bucket.bucket_id ? 'active' : ''}`}
                        onClick={() => setSelectedTarget(bucket)}
                    >
                        {bucket.name}
                        <span className="badge bg-secondary ms-2">{bucket.user_count}</span>
                    </div>
                ))}
            </div>

            <div className="d-flex justify-content-end gap-2 mt-3">
                <ButtonComponent text="Cancel" type={ButtonType.MAIN} onClick={onCancel} />
                <ButtonComponent
                    text="Confirm Move"
                    type={ButtonType.MAIN}
                    onClick={() => selectedTarget && onConfirm(selectedTarget)}
                />
            </div>
        </div>
    );
};

export default MoveUserModal;
